export default class LogoSketch {
  constructor (element) {
    this.element = element
  }

  bindFuncs (funcs) {
    funcs.forEach(func => { this[func] = this[func].bind(this) })
  }

  // This is called just before logobar starts opening
  willStart () {}

  // this is called just after logobar has been opened
  didStart () {}

  // This is called just before logobar starts closing
  willClose () {}

  // This is called just after logobar has been closed
  didClose () {}
}
